<app-modal class="view-pdf-modal">
    <ng-container modal-header>
        <h4 class="modal-title">{{ name }}</h4>
    </ng-container>
    <ng-container modal-body>
        <div class="pdf-container">
            <pdf-viewer *ngIf="showPdfViewer"
                        [src]="pdfLink"
                        [original-size]="false"
            ></pdf-viewer>

            <div *ngIf="!showPdfViewer" class="unsupported-file-card">
                <h3>{{ 'previewDocuments.notAvailable.title'| translate }}</h3>
                <p>{{ 'previewDocuments.notAvailable.description'| translate }}</p>
                <div class="download" (click)="downloadFile()" *ngIf="hasDownload()">
                    <i class="fa fa-file-text-o"></i>
                    <p>{{ 'previewDocuments.notAvailable.download' | translate }}</p>
                </div>
            </div>
        </div>
    </ng-container>
    <ng-container modal-footer>
        <app-button type="simple"
                    (click)="close()">{{ 'generic.buttons.close' | translate }}
        </app-button>
    </ng-container>
</app-modal>
